import { createAction, props } from '@ngrx/store';
import { Tags } from './tags.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records tag'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records tag success', 
    props<{ listData: Tags[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records tag failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record tag',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record tag success', 
    props<{ singleData: Tags }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record tag failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record tag',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record tag success'
);
export const addRecordFailure = createAction(
    '[Data] Add record tag failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record tag',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record tag success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record tag failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record tag',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record tag success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record tag failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state tag',
);